/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { toast, Toaster } from "react-hot-toast";
import axios from "axios";
import { baseApiURL } from "../../baseUrl";

import Companies from "./Companies";
import Drives from "./Drives";
import Applications from "./Applications";
import Training from "./Training";
import Dashboard from "./Dashboard";
import Reports from "./Reports";
import StudentProfiles from "./StudentProfiles";
import NoticeTicker from "../../components/NoticeTicker";

const PlacementHome = () => {
  const router = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Dashboard");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    companiesCount: 0,
    drivesCount: 0,
    studentsPlaced: 0,
  });

  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (router.state === null && !activeToken) {
      navigate("/");
    }
    setLoad(true);

    // Listen for navbar profile click
    const handleOpenProfile = () => setSelectedMenu("Dashboard");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);

  const renderContent = () => {
    switch (selectedMenu) {
      case "Dashboard":
        return <Dashboard />;
      case "Companies":
        return <Companies />;
      case "Drives":
        return <Drives />;
      case "Applications":
        return <Applications />;
      case "Training":
        return <Training />;
      case "Student Profiles":
        return <StudentProfiles />;
      case "Reports":
        return <Reports />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <>
      {load && (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
          <Navbar />
          <Sidebar 
            selectedMenu={selectedMenu} 
            setSelectedMenu={setSelectedMenu} 
            userType="Placement" 
            isCollapsed={isSidebarCollapsed} 
            setIsCollapsed={setIsSidebarCollapsed}
          />
          
          {/* Main Content Area */}
          <div className={`transition-all duration-300 ${isSidebarCollapsed ? "md:ml-16 w-full md:w-[calc(100%-4rem)]" : "md:ml-64 w-full md:w-[calc(100%-16rem)]"} ml-0 min-h-[calc(100vh-4rem)]`}>
            <div className="p-4 md:p-6 lg:p-8 w-full space-y-6">
              <div className="w-full">
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      )}
      <Toaster position="bottom-center" />
    </>
  );
};

export default PlacementHome;
